var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 2C8.41217 2 8.61566 2.08429 8.76569 2.23431L11.1657 4.63432C11.4781 4.94673 11.4781 5.45327 11.1657 5.76569C10.8533 6.07811 10.3467 6.07811 10.0343 5.76569L8.2 3.93137L6.36569 5.76569C6.05327 6.0781 5.54673 6.07811 5.23431 5.76569C4.9219 5.45327 4.9219 4.94673 5.23431 4.63431L7.63432 2.23431C7.78434 2.08429 7.98783 2 8.2 2ZM5.23431 9.43431C5.54673 9.12189 6.05327 9.12189 6.36569 9.43431L8.2 11.2686L10.0343 9.43431C10.3467 9.12189 10.8533 9.12189 11.1657 9.43431C11.4781 9.74673 11.4781 10.2533 11.1657 10.5657L8.76569 12.9657C8.45327 13.2781 7.94673 13.2781 7.63431 12.9657L5.23431 10.5657C4.9219 10.2533 4.9219 9.74673 5.23431 9.43431Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchVertical);
export default __webpack_public_path__ + "static/media/switch-vertical.86b6ab623a4ee0ceb5b0b1384bddc2b1.svg";
export { ForwardRef as ReactComponent };